/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Status_AnsweringInputs */

const es_components_ask_questions_status_answering = /** @type {(inputs: Components_Ask_Questions_Status_AnsweringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respondé las preguntas`)
};

const en_components_ask_questions_status_answering = /** @type {(inputs: Components_Ask_Questions_Status_AnsweringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer the questions`)
};

/**
* | output |
* | --- |
* | "Answer the questions" |
*
* @param {Components_Ask_Questions_Status_AnsweringInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_status_answering = /** @type {((inputs?: Components_Ask_Questions_Status_AnsweringInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Status_AnsweringInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_status_answering(inputs)
	return en_components_ask_questions_status_answering(inputs)
});
export { components_ask_questions_status_answering as "components.ask_questions.status.answering" }